import { session } from '@frontend/util/storage';
import { getParams } from '@frontend/util/url';
import $ from 'jquery';

export const getCurrentNavigationTab = (forceFirst = true, onlyVisible = false) => {
  const visible = (onlyVisible) ? ':visible' : '';
  let currentTab = $(`.middle-nav-links .active${visible}`).closest('.nav-item');
  if ((!currentTab || !currentTab.length) && forceFirst) {
    currentTab = $(`.middle-nav-links .nav-item${visible}`).first();
  }
  return currentTab;
};

export const getRegionLanguageSection = (path) => {
  const defaultRegionLanguage = {
    region: 'na',
    language: 'en'
  };

  if (path === '/') {
    return defaultRegionLanguage;
  }
  const regionLanguageRe = /^\/([a-z]{2})\/(?:([a-z]{2})\/)*(?:([a-z-]+)\/)*/i;
  const valid = path.match(regionLanguageRe);

  if (valid) {
    while (valid) {
      const [, region, language, section] = valid;
      return {
        region: (language) ? region : undefined,
        language: language || region,
        section
      };
    }
  }

  return defaultRegionLanguage;
};

export const getNavigationTabFromSection = (onlyVisible = false, forceFirst = true) => {
  const { section } = getParams(location.search);
  const visible = (onlyVisible) ? ':visible' : '';
  let tab;
  if (section) {
    tab = $(`.middle-nav-links .nav-item[data-section='${section}']${visible}`);
  }
  if ((!tab || !tab.length) && forceFirst) {
    tab = getCurrentNavigationTab(forceFirst, onlyVisible);
  }
  return tab;
};

export const getBaseURL = (path) => {
  const { region, language, section } = getRegionLanguageSection(path);
  return `/${[region, language, section].filter(item => item).join('/')}`;
};

export const pageExists = url =>
  new Promise((resolve, reject) => {
    const exists = session.get(url);
    if (exists === undefined) {
      $.ajax({ url, type: 'HEAD' })
        .done(() => {
          session.set(url, true);
          resolve(true);
        })
        .fail(() => {
          session.set(url, false);
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(false);
        });
    } else {
      const action = (exists) ? resolve : reject;
      action(exists);
    }
  });

export const fullUrl = path => `${location.origin}${path}`;



// WEBPACK FOOTER //
// ./src/static/js/utils.js